import { AttributeValue } from '@/models/references-classification/attribute-value';

export class Attribute {
    public id: number = 0;
    public businessId: number = 0;
    public name?: string;
    public values: AttributeValue[] = [];

    get value(): number {
        return this.id;
    }

    get text(): string | undefined {
        return this.name;
    }

    constructor(json?: any) {
        if (!json) {
            return;
        }

        Object.assign(this, json, {
            values: json.values
                ? json.values.map((value: any) => new AttributeValue(value))
                : [],
        });
    }

    public clone(): Attribute {
        const attribute = new Attribute();

        attribute.id = this.id;
        attribute.businessId = this.businessId;
        attribute.name = this.name;
        attribute.values.push(...this.values.map((value) => value.clone()));

        return attribute;
    }
}
